<script setup>
import { Bell, BarChart3, FileBarChart, History, Sparkles, Building2 } from "lucide-vue-next";
import AnimatedSection from "./AnimatedSection.vue";

const features = [
  {
    icon: Bell,
    title: "Alertas de riesgo automatizadas",
    description: "Identifica comportamientos críticos y recibe notificaciones inmediatas cuando algo se sale de lo normal.",
  },
  {
    icon: BarChart3,
    title: "Análisis de productividad en remoto",
    description: "Comprende en profundidad cómo trabajan los equipos distribuidos y detecta cuellos de botella operativos.",
  },
  {
    icon: FileBarChart,
    title: "Informes automáticos",
    description: "Informes claros y exportables para auditorías, comité de dirección y seguimiento interno.",
  },
  {
    icon: History,
    title: "Historial de actividad",
    description: "Registro detallado y seguro de la actividad relevante, con trazabilidad y control de accesos.",
  },
  {
    icon: Sparkles,
    title: "Detección de anomalías por IA",
    description: "Modelos predictivos que anticipan desviaciones antes de que afecten al negocio.",
  },
  {
    icon: Building2,
    title: "Diseñado para entornos corporativos",
    description: "Arquitectura pensada para seguridad, escalabilidad e integración con tus sistemas existentes.",
  },
];
</script>

<template>
  <section id="features" class="py-24 bg-background relative scroll-mt-20">
    <!-- Top accent line -->
    <div class="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent/20 to-transparent" />
    
    <div class="container mx-auto px-6">
      <!-- Section header -->
      <AnimatedSection animation="fade-up">
        <h2 class="text-3xl md:text-4xl font-bold text-foreground text-center mb-16">
          Funcionalidades clave
        </h2>
      </AnimatedSection>

      <!-- Features grid -->
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        <AnimatedSection 
          v-for="(feature, index) in features"
          :key="index"
          animation="fade-up"
          :delay="index * 100"
        >
          <div class="group relative p-6 rounded-lg border border-border/40 bg-card/30 hover:bg-card/60 transition-all duration-300 hover:border-accent/30 h-full">
            <!-- Icon -->
            <div class="mb-4">
              <div class="w-10 h-10 rounded-md bg-background border border-border/50 flex items-center justify-center group-hover:border-accent/40 transition-colors">
                <component :is="feature.icon" class="w-5 h-5 text-accent/80" />
              </div>
            </div>

            <!-- Title -->
            <h3 class="text-lg font-semibold text-foreground mb-3">
              {{ feature.title }}
            </h3>

            <!-- Description -->
            <p class="text-sm text-muted-foreground leading-relaxed">
              {{ feature.description }}
            </p>

            <!-- Subtle corner accent on hover -->
            <div class="absolute top-0 right-0 w-16 h-16 opacity-0 group-hover:opacity-100 transition-opacity">
              <div class="absolute top-0 right-0 w-px h-8 bg-gradient-to-b from-accent/40 to-transparent" />
              <div class="absolute top-0 right-0 w-8 h-px bg-gradient-to-l from-accent/40 to-transparent" />
            </div>
          </div>
        </AnimatedSection>
      </div>
    </div>
  </section>
</template>
